import type {
  StoryApiItem,
  StoryContent,
  StoryContentApiItem,
  StoryMediaType,
  StorySummary,
} from "../../../@types/portalAluno";
import { asArray, asBoolean, asId, asText, firstText } from "../coerce";

const MEDIA_TYPE_BY_EXTENSION: Record<string, StoryMediaType> = {
  bmp: "image",
  gif: "image",
  jpeg: "image",
  jpg: "image",
  png: "image",
  svg: "image",
  webp: "image",
  m4v: "video",
  mov: "video",
  mp4: "video",
  webm: "video",
  aac: "audio",
  m4a: "audio",
  mp3: "audio",
  ogg: "audio",
  wav: "audio",
  pdf: "pdf",
};

export const getStoryMediaType = (mediaUrl: string): StoryMediaType => {
  const extension = mediaUrl
    .split(/[?#]/)[0]
    .split(".")
    .pop()
    ?.toLocaleLowerCase("en-US");

  return (extension && MEDIA_TYPE_BY_EXTENSION[extension]) || "embed";
};

export const mapApiStories = (value: unknown): StorySummary[] => {
  const seenIds = new Set<number>();

  return asArray<StoryApiItem>(value).reduce<StorySummary[]>(
    (stories, item) => {
      const id = asId(item.idStory);
      const title = asText(item.nmStory);

      if (!id || !title || seenIds.has(id)) return stories;

      seenIds.add(id);
      stories.push({
        id,
        imageUrl: asText(item.imgStory),
        seen: asBoolean(item.isRealizado),
        title,
      });
      return stories;
    },
    []
  );
};

export const mapApiStoryContents = (value: unknown): StoryContent[] => {
  const seenIds = new Set<number>();

  return asArray<StoryContentApiItem>(value).reduce<StoryContent[]>(
    (contents, item) => {
      const id = asId(item.idStoryConteudo);
      const mediaUrl = asText(item.pathConteudo);

      if (!id || !mediaUrl || seenIds.has(id)) return contents;

      seenIds.add(id);
      contents.push({
        id,
        liked: asBoolean(item.isLike),
        mediaType: getStoryMediaType(mediaUrl),
        mediaUrl,
        seen: asBoolean(item.finish),
        title: firstText(item.nmConteudo) ?? "",
      });
      return contents;
    },
    []
  );
};
